import { Text, Title } from '@mantine/core'
import { FC } from 'react'

import classes from './Error404.module.css'

const Error404: FC = () => {
  return (
    <>
      <div className={classes.label}>404</div>
      <Title className={classes.title}>Not Found!</Title>
      <Text color='dimmed' size='lg' align='center' className={classes.description}>
        We did not find the page you are looking for.
      </Text>
    </>
  )
}

export { Error404 }
